import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';
import formsReducersMap from './forms/reducersMap';
import listsReducersMap from './lists/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  lists: listsReducersMap,
  forms: formsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('userBlackList', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/combineRegistry.js